import { ItxFramePage } from '@/pages/itxframe/ItxFramePage';
import { redirect, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/itxframe/')({
	component: ItxFramePage,
	validateSearch: z.object({
		customerID: z.coerce.string().min(1).optional(),
		corpId: z.coerce.number().int().positive().optional(),
	}),
	beforeLoad: ({ context, search }) => {
		if (!context.globalStore.getState().authenticated) {
			const params = new URLSearchParams();
			if (search.customerID) params.set('customerID', search.customerID);
			if (search.corpId) params.set('corpId', String(search.corpId));
			const qs = params.toString();
			throw redirect({
				to: '/login',
				search: { redirect: `/itxframe/${qs ? `?${qs}` : ''}` },
			});
		}
	},
});
